import RelatedOrdersTable from './RelatedOrdersTable/RelatedOrdersTable'
import ContainersUsageTable from './ContainersUsageTable'

const RelatedOrders = ({
    id,
}: { id: number }) => {
    return (
        <>
            <RelatedOrdersTable longTermLeaseId={id} />
            <ContainersUsageTable longTermLeaseId={id} />
        </>
    )
}

export default RelatedOrders
